export default __webpack_public_path__ + "static/media/bambooHR.26953291.png";